import { IRuleValidation, IRuleValidationResult, IRuleWarnings, RuleWarningType } from '../rule.interface';
import { isRuleUselessMessageItem } from './isRuleUselessMessageItem';

// Message items come from a previous rejection and are superseded by the new one.
const withoutMessageItems = (warnings?: IRuleWarnings): IRuleWarnings | undefined => {
  if (!warnings || !(RuleWarningType.Useless in warnings)) {
    return warnings;
  }
  const useless = warnings.useless.filter((item) => !isRuleUselessMessageItem(item));
  return useless.length > 0 ? { useless } : undefined;
};

// A rejected request (400 with rejectedRecords) says nothing about the rules it did not name,
// so every row keeps its last backend-reported state and only the named rows get the new
// validation. Indexes address the active (non-deleted) rules in the order they were sent.
export const mergeRejectedRuleValidation = (
  rules: IRuleValidation[],
  rejected: IRuleValidationResult[],
): IRuleValidationResult[] => {
  const rejectedByIndex = new Map(rejected.map((item) => [item.index, item]));

  return rules.map((rule, index) => {
    const item = rejectedByIndex.get(index);
    return {
      index,
      errors: item?.errors ?? rule.errors,
      warnings: item ? item.warnings : withoutMessageItems(rule.warnings),
    };
  });
};
